import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryCoverageColumn } from '../constants/dictionary-coverage-columns.constant';

export const generateCoverageColumns = () => {
	return [
		{
			title: dictionaryCoverageColumn[Enviroment.LANGUAGE].coverage_type,
			dataIndex: 'coverage_type',
			key: 'coverage_type',
		},
		{
			title: dictionaryCoverageColumn[Enviroment.LANGUAGE].health_coverage,
			dataIndex: 'health_coverage',
			key: 'health_coverage',
		},
		{
			title: dictionaryCoverageColumn[Enviroment.LANGUAGE].plan,
			dataIndex: 'plan',
			key: 'plan',
		},
		{
			title: dictionaryCoverageColumn[Enviroment.LANGUAGE].social_number,
			dataIndex: 'social_number',
			key: 'social_number',
		},
		{
			title: dictionaryCoverageColumn[Enviroment.LANGUAGE].token,
			dataIndex: 'token',
			key: 'token',
		},
	];
};
